// Initialize Swiper when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Check if product slider exists
  const productGridSlider = document.querySelector('.product-slider');
  const productColorGridSliders = document.querySelectorAll('.product-variant-slider');
  const collectionSlider = document.querySelector('.collection-slider');

  if (productGridSlider) {
    // Function to set equal heights for all anchor tags inside slides
    const setEqualSlideHeights = () => {
      const slideAnchors = productGridSlider.querySelectorAll('.swiper-slide a');
      let maxHeight = 0;

      // First, reset all heights to auto to get natural heights
      slideAnchors.forEach(anchor => {
        anchor.style.height = 'auto';
      });

      // Find the maximum height
      slideAnchors.forEach(anchor => {
        const height = anchor.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      });

      // Set all anchors to the maximum height
      slideAnchors.forEach(anchor => {
        anchor.style.height = `${maxHeight}px`;
      });
    };

    // Initialize Swiper
    const swiper = new Swiper(productGridSlider, {
      speed: 1000,
      // Optional parameters
      slidesPerView: 4,
      spaceBetween: 0,
      loop: false,

      // Enable equal height slides
      autoHeight: false,

      // Enable touch navigation
      allowTouchMove: true,
      grabCursor: true,

      direction: 'horizontal', // Swiper by default is horizontal, but specifying it here is helpful
      mousewheel: {
        enabled: true,
        //releaseOnEdges: true, // Allows only horizontal scroll
        forceToAxis: true,
      },

      // Responsive breakpoints
      breakpoints: {
        // Mobile - 1 slide
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          navigation: {
            enabled: true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
        // Tablet - 2 slides
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          navigation: {
            enabled: true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
        // Desktop - 4 slides
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          navigation: {
            enabled: true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
      },

      // Navigation buttons styling
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: 'swiper-button-disabled',
      },

      // Call setEqualSlideHeights on initialization and after resize
      on: {
        init: setEqualSlideHeights,
        resize: setEqualSlideHeights
      }
    });
    }

    document.querySelectorAll('.product-card').forEach(productCard => {
      let originalContent = null;
      let timeoutId = null;
      const hoverContainer = productCard.querySelector('.product-image-hover');

      if (!hoverContainer) return;

      // Store original content when first hovering any swatch
      const storeOriginalContent = () => {
          if (!originalContent) {
              originalContent = hoverContainer.innerHTML;
          }
      };

      productCard.querySelectorAll('.color-swatch').forEach(swatch => {
          swatch.addEventListener('mouseover', () => {
              // Clear any pending timeout
              if (timeoutId) {
                  clearTimeout(timeoutId);
                  timeoutId = null;
              }

              const variantImage = swatch.dataset.variantImage;
              if (variantImage) {
                  storeOriginalContent();

                  // Create a new image element
                  const newImage = document.createElement('img');
                  newImage.src = variantImage;
                  newImage.className = "w-full aspect-[281/376] object-contain transition-opacity duration-300";

                  // Replace the content with the new image
                  hoverContainer.innerHTML = '';
                  hoverContainer.appendChild(newImage);
              }
          });

          swatch.addEventListener('mouseout', () => {
              // Check if we're still hovering over any color swatch in this product card
              const isHoveringAnySwatch = Array.from(productCard.querySelectorAll('.color-swatch'))
                  .some(otherSwatch => otherSwatch.matches(':hover'));

              if (!isHoveringAnySwatch && originalContent) {
                  // Only restore if not hovering any swatch
                  timeoutId = setTimeout(() => {
                      hoverContainer.innerHTML = originalContent;
                  }, 1000);
              }
          });
      });
    });


  if (productColorGridSliders.length > 0) {
    productColorGridSliders.forEach(slider => {
      // Initialize Swiper
      const swiper = new Swiper(slider, {
        speed: 1000,
        // Optional parameters
        slidesPerView: 4,
        spaceBetween: 8,
        loop: false,

        // Enable equal height slides
        autoHeight: false,

        // Enable touch navigation
        allowTouchMove: true,
        grabCursor: true,

        direction: 'horizontal', // Swiper by default is horizontal, but specifying it here is helpful
        mousewheel: {
            enabled: true,
            //releaseOnEdges: true, // Allows only horizontal scroll
            forceToAxis: true,
        },

        // Responsive breakpoints
        breakpoints: {
          // Mobile - 1 slide
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: {
              enabled: true,
              nextEl: slider.querySelector('.swiper-button-next'),
              prevEl: slider.querySelector('.swiper-button-prev'),
            }
          },
          // Tablet - 2 slides
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            navigation: {
              enabled: true,
              nextEl: slider.querySelector('.swiper-button-next'),
              prevEl: slider.querySelector('.swiper-button-prev'),
            }
          },
          // Desktop - 4 slides
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            navigation: {
              enabled: true,
              nextEl: slider.querySelector('.swiper-button-next'),
              prevEl: slider.querySelector('.swiper-button-prev'),
            }
          },
        },

        // Navigation buttons styling
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
          disabledClass: 'swiper-button-disabled',
        }
      });
    });
  }

  // Initialize Collection Slider
  if (collectionSlider) {
    const collectionSwiper = new Swiper(collectionSlider, {
      speed: 1000,
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: false,
      allowTouchMove: true,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      direction: 'horizontal', // Swiper by default is horizontal, but specifying it here is helpful
      mousewheel: {
        enabled: true,
        //releaseOnEdges: true, // Allows only horizontal scroll
        forceToAxis: true,
      },

      // Responsive breakpoints
      breakpoints: {
        // Mobile - 1 slide
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 8,
          enabled: true,
          navigation: {
            enabled: true,
            nextEl: collectionSlider.querySelector('.swiper-button-next'),
            prevEl: collectionSlider.querySelector('.swiper-button-prev'),
          }
        },
        // Tablet - 2 slides
        640: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 8,
          enabled: true,
          navigation: {
            enabled: true,
            nextEl: collectionSlider.querySelector('.swiper-button-next'),
            prevEl: collectionSlider.querySelector('.swiper-button-prev'),
          }
        },
        // Desktop - disable swiper
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 8,
          enabled: true,
          navigation: {
            enabled: true,
            nextEl: collectionSlider.querySelector('.swiper-button-next'),
            prevEl: collectionSlider.querySelector('.swiper-button-prev'),
          }
        }
      },

      // Navigation buttons styling
      navigation: {
        nextEl: collectionSlider.querySelector('.swiper-button-next'),
        prevEl: collectionSlider.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-button-disabled',
      }
    });
  }
});
